import React from 'react';
import { trackFbEvent } from '../utils/fbpixel';
import { useCountdown } from '../utils/useCountdown';
export function FinalCTA() {
  const t = useCountdown();
  const pad = (n: number) => String(n).padStart(2, '0');
  const standardUrl = 'https://biologiafemenina.com.ar/checkouts/cn/hWNAyoSYZJTJbTg7kMIErTs2/es-ar?_r=AQABYH4AJEYbldjv1X8ikRhvCxTQaIS18_dlVcs3rsXEGpw';
  const vipUrl = 'https://biologiafemenina.com.ar/checkouts/cn/hWNAyoLK7WK3TzXI3v5RGX0k/es-ar?_r=AQABT_wKLpoN4NHawYiBZBU4FMM4DkBu3EjImLlsMOvhfHk';
  return <section className="w-full bg-brand-violet px-6 py-16 flex flex-col justify-center" style={{
    minHeight: '100dvh'
  }} data-id="element-36">
      <div className="max-w-md mx-auto w-full flex flex-col items-center text-center" data-id="element-37">
        <p className="text-white/70 text-[12px] font-bold uppercase tracking-widest mb-6" data-id="element-38">
          Biología Femenina · Método pH-ZERO
        </p>

        <h2 className="text-[32px] font-bold text-white mb-10 leading-tight" data-id="element-39">
          Tu cuerpo no está fallado. Solo necesitaba la información correcta.
        </h2>

        <div className="flex items-center justify-center gap-4 mb-10" data-id="element-40">
          <div className="flex flex-col items-center" data-id="element-41">
            <span className="text-white font-bold text-[32px] leading-none" data-id="element-42">
              {pad(t.hours)}
            </span>
            <span className="text-white/70 text-[10px] uppercase font-bold mt-1" data-id="element-43">
              Horas
            </span>
          </div>
          <span className="text-white/50 text-[24px] font-bold -mt-4" data-id="element-44">:</span>
          <div className="flex flex-col items-center" data-id="element-45">
            <span className="text-white font-bold text-[32px] leading-none" data-id="element-46">
              {pad(t.minutes)}
            </span>
            <span className="text-white/70 text-[10px] uppercase font-bold mt-1" data-id="element-47">
              Minutos
            </span>
          </div>
          <span className="text-white/50 text-[24px] font-bold -mt-4" data-id="element-48">:</span>
          <div className="flex flex-col items-center" data-id="element-49">
            <span className="text-white font-bold text-[32px] leading-none" data-id="element-50">
              {pad(t.seconds)}
            </span>
            <span className="text-white/70 text-[10px] uppercase font-bold mt-1" data-id="element-51">
              Segundos
            </span>
          </div>
        </div>

        <div className="w-full flex flex-col gap-4 mb-8" data-id="element-52">
          <a href={standardUrl} target="_blank" rel="noopener noreferrer" onClick={() => trackFbEvent('InitiateCheckout', {
          content_name: 'Final CTA Standard',
          value: 19990,
          currency: 'ARS'
        })} className="w-full block bg-white hover:bg-gray-50 text-brand-violet font-bold text-[15px] rounded-xl py-4 text-center transition-all" data-id="element-53">
            📘 SISTEMA ORIGINAL — $19.990 ARS
          </a>

          <a href={vipUrl} target="_blank" rel="noopener noreferrer" onClick={() => trackFbEvent('InitiateCheckout', {
          content_name: 'Final CTA VIP',
          value: 29990,
          currency: 'ARS'
        })} className="w-full block bg-brand-magenta hover:brightness-110 text-white font-bold text-[15px] rounded-xl py-4 text-center transition-all shadow-[0_4px_24px_rgba(212,0,110,0.25)]" data-id="element-54">
            👑 PACK COMPLETO — $29.990 ARS
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-[11px] text-white/60 font-medium" data-id="element-55">
          <span data-id="element-56">🔒 Pago 100% seguro</span>
          <span className="hidden sm:inline" data-id="element-57">•</span>
          <span data-id="element-58">⚡ Acceso en 5 minutos</span>
          <span className="hidden sm:inline" data-id="element-59">•</span>
          <span data-id="element-60">🛡️ Garantía 7 días</span>
          <span className="hidden sm:inline" data-id="element-61">•</span>
          <span data-id="element-62">💳 Mercado Pago</span>
        </div>
      </div>
    </section>;
}